define((require) => {
    "use strict";

    const Backbone          = require("backbone");
    const GroupAsset        = require("shared/ui/groups/GroupAsset");
    const GroupValueFactory = require("shared/ui/groups/GroupValueFactory");

    /**
     * A collection of group <i>assets</i>.
     *
     * @see GroupAsset
     *
     * @class GroupAssetCollection
     */
    return Backbone.Collection.extend("Group Asset Collection", {

        model(attributes, options) {
            // Overwrite the value with the concrete data type/value
            attributes.value = GroupValueFactory.create(attributes);
            attributes.asset = options.assetFactory(attributes);

            return new GroupAsset(attributes);
        },

        // TODO: Put attach/detach in a editor specific mixin?
        attach(asset, value, valueType) {
            return this.add(GroupAsset.asAsset(asset, value, valueType));
        },

        /**
         * Removes the entry (or entries) by the specified asset and/or value.<p>
         *
         * If no value is specified, all the entries represented by the asset are removed.
         *
         * @param  {ImprovedModel} asset The asset.
         * @param  {*}             value The optional value.
         *
         * @return {Boolean}       <tt>true</tt> if entries where removed.
         */
        detach(asset, value) {
            const entriesToRemove = this.filter((internalAsset) => {
                const assetFound = internalAsset.get("asset").get("id") === asset.get("id");
                let valueFound = true;

                if (value) {
                    valueFound = internalAsset.get("value") === value;
                }

                return assetFound && valueFound;
            });

            if (entriesToRemove) {
                return !!this.remove(entriesToRemove);
            }

            return false;
        },

        findAssetById(id) {
            return this.find((asset) => asset.get("id") === id);
        }
    });
});



// WEBPACK FOOTER //
// ./src/shared/ui/groups/GroupAssetCollection.js